import { BoxArrowUpRight } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { Button, Divider, notification, Typography } from 'antd';

import HelpForm from '@/components/shared/HelpForm';
import PageTitle from '@/components/shared/PageTitle';
import Wrapper from '@/components/shared/Wrapper';
import styled, { css, StyledProp } from '@/styled';

const data = [
  {
    title: 'Como aceito o convite de um curso que recebi no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933709627547'
  },
  { title: 'Como acessar um curso no Nutror?', link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260806911609' },
  {
    title: 'Como acesso o Portal do produtor no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933779393051'
  },
  {
    title: 'Como alterar as configurações de notificações de e-mail, dentro do Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/7270818682523'
  },
  {
    title: 'Como altero a visualização do Nutror para Modo Claro ou Modo Escuro?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933766184731'
  },
  {
    title: 'Como altero meus dados de aluno no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933790589083'
  },
  { title: 'Como baixar o aplicativo do Nutror?', link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807547589' },
  {
    title: 'Como entrar em contato com o produtor do curso no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933787247643'
  },
  {
    title: 'Como fazer o download das aulas do Safevídeo dentro do app Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/8611829296667'
  },
  {
    title: 'Como fazer o download de arquivos? (Nutror)',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/8613522053915'
  },
  {
    title: 'Como funciona o processo de unificação de contas no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/10037983599771'
  },
  {
    title: 'Como gerar e baixar meu certificado de um curso no app Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/7114766984347'
  },
  {
    title: 'Como gerar e imprimir meu certificado de um curso no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807552209'
  },
  { title: 'Como limpar o cache no Nutror', link: 'https://ajuda.eduzz.com/hc/pt-br/articles/4402543655323' },
  { title: 'Como marcar minha aula como concluída?', link: 'https://ajuda.eduzz.com/hc/pt-br/articles/10203768544283' },
  { title: 'Como salvar aulas dentro do Nutror?', link: 'https://ajuda.eduzz.com/hc/pt-br/articles/7765146254619' },
  {
    title: 'Como visualizo meus comentários no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933789299483'
  },
  {
    title: 'Como visualizo o progresso do meu curso no Nutror?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933768275483'
  },
  {
    title: 'Esqueci minha senha/dados inválidos – Nutror',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807655570'
  },
  {
    title: 'Tenho um curso no Nutror que vai expirar, como faço a renovação do acesso?',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/14933791953563'
  }
];

const Help = ({ className }: StyledProp) => {
  const [, contextHolder] = notification.useNotification();

  const openHelpCenterLink = () => {
    window.open('https://ajuda.eduzz.com/?article-category=nutror', '_blank', 'noopener noreferrer');
  };

  return (
    <Wrapper size='medium' className={className}>
      {contextHolder}

      <PageTitle title='Ajuda' breadcrumbItems={[{ title: <Link to='/resumo'>Resumo</Link> }, { title: 'Ajuda' }]} />

      <div className='help-container'>
        <Typography.Title level={5} ellipsis>
          Dúvidas Frequentes
        </Typography.Title>

        <div className='help-questions'>
          {data.map((item, index) => (
            <div key={index} className='help-questions-item'>
              <Typography.Link href={item.link} rel='noopener noreferrer' target='_blank'>
                {index + 1} - {item.title}
              </Typography.Link>

              <Typography.Link href={item.link} rel='noopener noreferrer' target='_blank'>
                <BoxArrowUpRight size={20} />
              </Typography.Link>
            </div>
          ))}
        </div>

        <div className='help-form'>
          <HelpForm />
        </div>

        <Divider className='divider' />

        <div className='help-center'>
          <Typography.Title level={4} ellipsis={true}>
            Central de ajuda
          </Typography.Title>

          <Typography.Text>Não achou o que precisa? Acesse nossa Central de Ajuda!</Typography.Text>

          <Button size='large' type='ghost' className='help-center-button' onClick={openHelpCenterLink}>
            Central de ajuda
            <BoxArrowUpRight />
          </Button>
        </div>
      </div>
    </Wrapper>
  );
};

export default styled(Help)(({ theme }) => {
  return css`
    .help-container {
      display: flex;
      flex-direction: column;
      gap: ${theme.space.spacing(1)};
      padding-top: 24px;

      ${theme.breakpoints.down('md')} {
        padding-left: ${theme.space.spacing(4)};
        margin-right: ${theme.space.spacing(4)};
      }

      h5.ant-typography {
        font-size: ${theme.space.pxToRem(20)};
        font-weight: 400;
        margin-bottom: 44px;
      }
    }

    .help-questions {
      padding-bottom: 48px;

      .help-questions-item {
        font-weight: 700;
        padding: 16px 16px;
        border-bottom: 1px solid ${theme.variables.dividerColor};
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          font-size: ${theme.space.pxToRem(16)};
          color: ${theme.colorTextBase};
        }

        svg {
          color: ${theme.colorTextBase};
        }
      }
    }

    .help-form {
      padding-top: 24px;
      padding-bottom: 48px;
    }

    .divider {
      border-color: ${theme.variables.dividerColor};
      margin: ${theme.space.spacing(2)} 0;
    }

    .answer {
      font-weight: normal;
      color: ${theme.colorTextTertiary};
    }

    .help-center {
      display: flex;
      flex-direction: column;
      margin-top: 48px;
      gap: 24px;
      align-items: flex-start;

      h4.ant-typography {
        font-size: ${theme.space.pxToRem(20)};
        font-weight: 400;
        margin-bottom: 0;
      }
    }

    .help-center-button {
      background-color: ${theme.variables.bgComponentsContainer};
      display: flex;
      align-items: center;
      column-gap: ${theme.space.spacing(2)};
    }
  `;
});
